// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__1enSu","header":"Details_header__3Ghc0","footer":"Details_footer__DubR0"};